export default "__VITE_ASSET__BoKpwHOd__"